export class ChildrenCountWithCategoriesResult
{
    TotalChildren!: number;
    MatchingChildIds: number[] = [];

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
    }
}
